'use client';

import { c as _c } from "react/compiler-runtime";
import { BuilderBlocks } from '@builder.io/react';
import { useState } from 'react';
import { Dropdown } from '@src/components/Dropdown/Dropdown';
import { getBuilderPreviewMode } from '@src/utils/builder.util';
import type { ContentSwitcherProps } from './ContentSwitcher.props';
export const ContentSwitcher = props => {
  const $ = _c(15);
  const {
    items: t0,
    builderBlock,
    defaultIndex: t1,
    previewMode: t2
  } = props;
  let t3;
  if ($[0] !== t0) {
    t3 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const items = t3;
  const defaultIndex = t1 === undefined ? 0 : t1;
  const previewMode = t2 === undefined ? false : t2;
  const [selectedIndex, setSelectedIndex] = useState(defaultIndex);
  let t4;
  if ($[2] !== previewMode) {
    t4 = getBuilderPreviewMode().edit && previewMode;
    $[2] = previewMode;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const isPreviewing = t4;
  let t5;
  if ($[4] !== builderBlock?.id || $[5] !== items || $[6] !== selectedIndex) {
    t5 = () => <div><div className="flex flex-col justify-between lg:flex-row lg:gap-8"><BuilderBlocks parentElementId={builderBlock?.id} blocks={items[selectedIndex]?.contentTop} dataPath={`component.options.items.${selectedIndex}.contentTop`} /><div className="w-full shrink-0 lg:w-[240px]"><Dropdown items={items.map(_temp)} selectedId={items[selectedIndex].title ?? ""} onItemIdSelected={id => setSelectedIndex(items.findIndex(item_0 => item_0.title === id))} /></div></div><BuilderBlocks parentElementId={builderBlock?.id} blocks={items[selectedIndex]?.contentBottom} dataPath={`component.options.items.${selectedIndex}.contentBottom`} /></div>;
    $[4] = builderBlock?.id;
    $[5] = items;
    $[6] = selectedIndex;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const renderContent = t5;
  let t6;
  if ($[8] !== builderBlock?.id || $[9] !== items) {
    t6 = () => <div className="flex flex-col gap-8">{items.map((item_1, index) => <div key={item_1.title} className="flex flex-col gap-4"><div className="border-b border-bodi-gray-butters pb-2 font-mono text-body-lg font-bold text-blue-500">Previewing item: {item_1.title}</div><BuilderBlocks parentElementId={builderBlock?.id} blocks={item_1?.contentTop} dataPath={`component.options.items.${index}.contentTop`} /><BuilderBlocks parentElementId={builderBlock?.id} blocks={item_1?.contentBottom} dataPath={`component.options.items.${index}.contentBottom`} /></div>)}</div>;
    $[8] = builderBlock?.id;
    $[9] = items;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const renderPreviewContent = t6;
  let t7;
  if ($[11] !== isPreviewing || $[12] !== renderContent || $[13] !== renderPreviewContent) {
    t7 = <>{isPreviewing ? renderPreviewContent() : renderContent()}</>;
    $[11] = isPreviewing;
    $[12] = renderContent;
    $[13] = renderPreviewContent;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
function _temp(item) {
  return {
    id: item.title ?? "",
    displayName: item.title ?? "",
    name: item.title ?? ""
  };
}